import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/auth";
import { CartProvider } from "./lib/cart";
import { ThemeProvider } from "./lib/theme";
import { DiscountProvider } from "./lib/discount";
import { CountryProvider } from "./lib/country";
import { LanguageProvider } from "./lib/language";
import Navbar from "./components/Navbar";
import SearchBar from "./components/SearchBar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import CheckoutResult from "./pages/CheckoutResult";
import PayPalReturn from "./pages/PayPalReturn";
import AuthPage from "./pages/AuthPage";
import Profile from "./pages/Profile";
import VendorDashboard from "./pages/VendorDashboard";
import VendorPublic from "./pages/VendorPublic";
import VendorsIndex from "./pages/VendorsIndex";
import Admin from "./pages/Admin";
import Support from "./pages/Support";
import Tracking from "./pages/Tracking";
import Returns from "./pages/Returns";
import SiteReviews from "./pages/SiteReviews";
import FeedbackWidget from "./components/FeedbackWidget";
import SuggestionCampaign from "./components/SuggestionCampaign";
import SiteModeBanner from "./components/SiteModeBanner";
import CountryPicker from "./components/CountryPicker";
import HowTo from "./pages/HowTo";
import LegalPage from "./pages/LegalPage";
import SolicitarProducto from "./pages/SolicitarProducto";
import ResetPassword from "./pages/ResetPassword";
import "./App.css";

function App() {
    return (
        <AuthProvider>
            <DiscountProvider>
            <CartProvider>
                <CountryProvider>
                <LanguageProvider>
                <ThemeProvider>
                    <BrowserRouter>
                        <div className="min-h-screen flex flex-col bg-[var(--tb-bg)] text-[var(--tb-text)]">
                            <Navbar />
                            <SearchBar />
                            <SiteModeBanner />
                            <SuggestionCampaign />
                            <CountryPicker />
                            <main className="flex-1">
                                <Routes>
                                    <Route path="/" element={<Home />} />
                                    <Route path="/tienda" element={<Shop />} />
                                    <Route path="/producto/:sku" element={<ProductDetail />} />
                                    <Route path="/carrito" element={<Cart />} />
                                    <Route path="/checkout" element={<Checkout />} />
                                    <Route path="/checkout/success" element={<CheckoutResult kind="success" />} />
                                    <Route path="/checkout/cancel" element={<CheckoutResult kind="cancel" />} />
                                    <Route path="/paypal/return" element={<PayPalReturn kind="return" />} />
                                    <Route path="/paypal/cancel" element={<PayPalReturn kind="cancel" />} />
                                    <Route path="/login" element={<AuthPage mode="login" />} />
                                    <Route path="/registro" element={<AuthPage mode="register" />} />
                                    <Route path="/reset-password" element={<ResetPassword />} />
                                    <Route path="/perfil" element={<Profile />} />
                                    <Route path="/vendedor" element={<VendorDashboard />} />
                                    <Route path="/v/:vid" element={<VendorPublic />} />
                                    <Route path="/vendedores" element={<VendorsIndex />} />
                                    <Route path="/admin" element={<Admin />} />
                                    <Route path="/soporte" element={<Support />} />
                                    <Route path="/tracking" element={<Tracking />} />
                                    <Route path="/devoluciones" element={<Returns />} />
                                    <Route path="/reviews" element={<SiteReviews />} />
                                    <Route path="/solicitar-producto" element={<SolicitarProducto />} />
                                    <Route path="/como-usar" element={<HowTo />} />
                                    <Route path="/legal/terminos" element={<LegalPage slug="terminos" />} />
                                    <Route path="/legal/privacidad" element={<LegalPage slug="privacidad" />} />
                                    <Route path="/legal/seguridad" element={<LegalPage slug="seguridad" />} />
                                    <Route path="/legal/cumplimiento" element={<LegalPage slug="cumplimiento" />} />
                                </Routes>
                            </main>
                            <Footer />
                            <FeedbackWidget />
                            <Toaster position="top-right" />
                        </div>
                    </BrowserRouter>
                </ThemeProvider>
                </LanguageProvider>
                </CountryProvider>
            </CartProvider>
            </DiscountProvider>
        </AuthProvider>
    );
}

export default App;
